export enum SiteFieldNames {
  Address = 'address',
  Areas = 'areas',
  Body = 'body',
  Code = 'code',
  ConductCodeSections = 'conductCodeSections',
  ContactInfo = 'contact-info',
  Description = 'description',
  Email = 'email',
  LocationInfo = 'location-info',
  LocationPhoto = 'location-photo',
  LocationPhotoAttached = 'locationPhotoAttached',
  LocationPoint = 'locationPoint',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  PointerColor = 'pointerColor',
  PointerIconAttached = 'pointerIconAttached',
  PointerShape = 'pointerShape',
  PoorWifi = 'poorWifi',
  Sector = 'sector',
  SectorWarning = 'sector-warning',
  SiteDetails = 'site-details',
  SitePointerDesign = 'sitePointerDesign',
  Title = 'title',
  UserId = 'userId',
  UserMemberships = 'userMemberships',
  UserMembershipsList = 'userMemberships-list',
  UserMembershipsTitle = 'userMemberships-title',
}
